export type UserRole = "superuser" | "retailer" | "store_employee";

export const RoleLabel: Record<UserRole, string> = {
  superuser: "Super User",
  retailer: "Location Manager",
  store_employee: "Store team"
};

export interface AuthUser {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: UserRole;
  forcePasswordReset?: boolean;
}

export interface LoginPayload {
  email: string;
  password?: string;
}

export interface AuthContextValue {
  user: (AuthUser & { fullName: string }) | null;
  isLoading: boolean;
  login: (payload: LoginPayload) => Promise<void>;
  logout: () => void;
  refreshUser: () => Promise<void>;
}

// Backend user response type (user_type matches UserType enum values)
export interface UserBase {
  id: string;
  email: string;
  first_name?: string;
  last_name?: string;
  user_type: "superuser" | "owner" | "store_employee";
  is_active: boolean;
  force_password_reset?: boolean;
}
